import { useSelector, shallowEqual } from 'react-redux';
import { Container } from '@plone/components';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import type { Content } from '@plone/types';

type FormState = {
  content: {
    data: Content;
  };
};

const contactLines = [
  {
    label: 'Seminare BR / PR / MAV',
    href: '/seminare',
    phone: '089 / 55 93 36 50',
    email: 'seminare@bildungswerk-bayern.de',
  },
  {
    label: 'TIBAY / Beratung',
    href: '/tibay-technologieberatung',
    phone: '089 / 55 93 36 28',
    email: 'florian.feichtmeier@bildungswerk-bayern.de',
  },
  {
    label: 'Münchenprogramm',
    href: '/muenchen-programm',
    phone: '089 / 55 93 36 40',
    email: 'anmeldung@bildungswerk-bayern.de',
  },
  {
    label: 'Politische Bildung',
    href: '/politische-bildung',
    phone: '089 / 55 93 36 41',
    email: 'politische.bildung@bildungswerk-bayern.de',
  },
];

const newsletterLinks = [
  {
    label: 'München Newsletter',
    href: '/newsletter',
  },
  {
    label: 'Bayern Newsletter',
    href: '/newsletter',
  },
];

const MailIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path
      d="M3 5h18v14H3z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="m3 6 9 7 9-7"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
);

const Footer = () => {
  const content = useSelector<FormState, Content>(
    (state) => state.content.data,
    shallowEqual,
  );

  return (
    <footer id="footer" aria-label="Footer">
      <Container className="pre-footer">
        <div className="main-footer__logo">
          <Logo />
        </div>
      </Container>
      <div className="main-footer">
        <div className="main-footer__inner">
          <address className="main-footer__address">
            <strong>DGB Bildungswerk Bayern e.V.</strong>
            <span>Schwanthalerstraße 64</span>
            <span>80336 München</span>
            <a href="tel:+49895593650">Tel. 089 / 55 93 36 50</a>
            <a className="main-footer__mail-link" href="mailto:seminare@bildungswerk-bayern.de">
              E-Mail senden <MailIcon />
            </a>
          </address>

          <div className="main-footer__contacts" aria-label="Kontaktbereiche">
            {contactLines.map(({ label, href, phone, email }) => (
              <div className="main-footer__contact" key={label}>
                <a className="main-footer__contact-link" href={href}>
                  {label}
                </a>
                <span aria-hidden="true">|</span>
                <a
                  className="main-footer__contact-phone"
                  href={`tel:${phone.replace(/[^+\d]/g, '')}`}
                >
                  Tel. {phone}
                </a>
                <span aria-hidden="true">|</span>
                <a
                  className="main-footer__contact-mail"
                  href={`mailto:${email}`}
                >
                  <MailIcon />
                </a>
              </div>
            ))}
          </div>

          <div className="main-footer__newsletter">
            <strong>Abonnieren Sie uns!</strong>
            <div>
              {newsletterLinks.map(({ label, href }) => (
                <UniversalLink
                  className="main-footer__newsletter-link"
                  href={href}
                  key={label}
                >
                  {label}
                </UniversalLink>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Container className="post-footer">
        <SlotRenderer name="postFooter" content={content} />
      </Container>
    </footer>
  );
};

export default Footer;
